import type { StateCreator } from 'zustand';

import type { ProjectSlice } from './types';

export type { ProjectSlice } from './types';

export const projectInitialState = {
  isRemoteProject: false,
  shouldSkipAutoGeneration: false,
};

export const createProjectSlice: StateCreator<
  ProjectSlice,
  [],
  [],
  ProjectSlice
> = (set) => ({
  ...projectInitialState,

  setIsRemoteProject: (isRemoteProject) => set({ isRemoteProject }),
  setShouldSkipAutoGeneration: (shouldSkipAutoGeneration) =>
    set({ shouldSkipAutoGeneration }),
});
